import { render, staticRenderFns } from "./AnnouncementBoxesContainer.vue?vue&type=template&id=cf1deeb4&scoped=true"
import script from "./AnnouncementBoxesContainer.vue?vue&type=script&lang=js"
export * from "./AnnouncementBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBoxesContainer.vue?vue&type=style&index=0&id=cf1deeb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1deeb4",
  null
  
)

export default component.exports